import { useSyncExternalStore } from 'react'
import { FlaskConical } from 'lucide-react'
import { isDemoMode, subscribeDemoMode } from '../utils/demoMode'
import { bluetoothService } from '../utils/bluetoothService'
import { useSystemStore } from '../stores/systemStore'
import { useTranslation } from '../locales'
import { useLanguageStore } from '../stores/languageStore'

/** 데모 모드 상시 배너 — 합성 데이터임을 명시하고 종료할 수 있게 한다. */
export default function DemoModeBanner() {
  const demo = useSyncExternalStore(subscribeDemoMode, isDemoMode, isDemoMode)
  const { currentLanguage } = useLanguageStore()
  const tDm = useTranslation(currentLanguage).deviceManager
  const disconnectDevice = useSystemStore((state) => state.disconnectDevice)

  if (!demo) return null

  const handleExit = async () => {
    try {
      if (bluetoothService.isConnected()) {
        await disconnectDevice()
      }
    } finally {
      bluetoothService.disableDemoMode()
    }
  }

  return (
    <div
      role="status"
      data-testid="demo-mode-banner"
      className="flex items-center justify-between gap-3 px-4 py-2 text-sm"
      style={{ background: 'rgba(245, 158, 11, 0.15)', borderBottom: '1px solid rgba(245, 158, 11, 0.4)', color: 'var(--fg-1)' }}
    >
      <div className="flex items-start gap-2 min-w-0">
        <FlaskConical className="w-4 h-4 shrink-0 mt-0.5" strokeWidth={1.5} />
        <span className="min-w-0">
          <span className="font-semibold mr-1.5">{tDm.demoBannerTitle}</span>
          <span>{tDm.demoBannerDesc}</span>
        </span>
      </div>
      <button type="button" onClick={handleExit} className="shrink-0 underline font-medium whitespace-nowrap">
        {tDm.demoExit}
      </button>
    </div>
  )
}
